import Vue from 'vue';

// When the request succeeds
const success = (data, context) => {
  context.loading = false;
  let href = document.createElement('a');
  if (context.form.redirect_type === 'url') {
    if(context.form.redirect_url.match('https://') || context.form.redirect_url.match('http://')) {
      href.href = context.form.redirect_url;
    } else {
      href.href = `https://${context.form.redirect_url}`;
    }
  } else if (context.form.redirect_type === 'file') {
    href.href = context.form.redirect_file;
  }
  href.click();
};

// When the request fails
const failed = (context, error) => {
  context.showToasterError(error);
  context.loading = false;
};

export default (context, updated_data, booking_permalink) => {
  return Vue.$http.put(`/update-booking-from-form/${booking_permalink}`, updated_data).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    }
  })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/form/updateBooking.js